// @ts-nocheck
/* Starter Sync - MyListsList */

import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer from "@insite/content-library/Components/CardContainer";
import CardList from "@insite/content-library/Components/CardList";
// import CardListHeading from "@insite/content-library/Components/CardListHeading"; // Starter Custom Code
// import WishListCard, { WishListCardStyles } from "@insite/content-library/Components/WishListCard"; // Starter Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import deleteWishList from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishList";
import deleteWishListShare from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishListShare";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import CardListHeading from "@store/Overrides/Components/CardListHeading";
import WishListCard, { WishListCardStyles } from "@store/Overrides/Components/WishListCard";
import { tableProps } from "@store/Themes/common/props/table";
import { typographyGetNoResultsProps } from "@store/Themes/common/props/typography";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import getWishlistShowFavorites from "@toolkit/Framework/Common/Utilities/wishlist/getWishlistShowFavorites";
import getWishlistShowTags from "@toolkit/Framework/Common/Utilities/wishlist/getWishlistShowTags";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";

interface HookProps {
    persistentDataView: ReturnType<typeof getWishListsDataView>;
    trackDeleteWishList: ReturnType<typeof ga.use.trackDeleteWishList>;
}

const hookPropsInjector: HookPropsInjector<Props, HookProps> = ({ recentWishListsDataView }) => ({
    persistentDataView: usePersistentDataView(recentWishListsDataView),
    trackDeleteWishList: ga.use.trackDeleteWishList(),
});

interface State {
    wishListToAction?: WishListModel;
    deleteListModalIsOpen: boolean;
    leaveListModalIsOpen: boolean;
}
/* Starter Custom Code - End */

const enum fields {
    numberOfRecords = "numberOfRecords",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.numberOfRecords]: number;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        recentWishListsDataView: getWishListsDataView(state, recentWishListsParameter),
        myListsPageNavLink: getPageLinkByPageType(state, "MyListsPage"),
        canViewWishLists: (session.isAuthenticated || session.rememberMe) && !session.isGuest,
    };
};

let recentWishListsParameter = {
    page: 1,
    sort: "ModifiedOn DESC",
    expand: ["top3products", "favorite", "hidden", "tags"],
    wishListLinesSort: "mostRecent",
} as GetWishListsApiParameter;

const mapDispatchToProps = {
    loadWishLists,
    addWishListToCart,
    updateWishList,
    // Starter Custom Code
    deleteWishList,
    deleteWishListShare,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HookProps; // Starter Custom Code

export interface RecentWishListsStyles {
    wishListCardGridItem?: GridItemProps;
    noWishListsText?: TypographyProps;
    wishListCard?: WishListCardStyles;
    // Starter Custom Code
    wrapper?: InjectableCss;
    loadingOverlay?: LoadingOverlayProps;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    listNameHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    itemsHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    actionsHeader?: DataTableHeaderProps;
}

export const recentWishListsStyles: RecentWishListsStyles = {
    noWishListsText: typographyGetNoResultsProps(),
    loadingOverlay: { minHeight: 80 },
    tableWrapper: tableProps.wrapper,
    actionsHeader: tableProps.tightHeader,
};

const styles = recentWishListsStyles;

class RecentWishLists extends React.Component<Props, State /* Starter Custom Code */> {
    /* Starter Custom Code - Start */
    static contextType = ToasterContext;
    context!: React.ContextType<typeof ToasterContext>;

    constructor(props: Props) {
        super(props);
        this.state = {
            deleteListModalIsOpen: false,
            leaveListModalIsOpen: false,
        };
    }
    /* Starter Custom Code - End */

    componentDidMount() {
        recentWishListsParameter.pageSize = this.props.fields.numberOfRecords;
        if (
            this.props.canViewWishLists &&
            !this.props.recentWishListsDataView.value &&
            !this.props.recentWishListsDataView.isLoading
        ) {
            this.props.loadWishLists(recentWishListsParameter);
        }
    }

    componentDidUpdate() {
        if (
            this.props.canViewWishLists &&
            !this.props.recentWishListsDataView.value &&
            !this.props.recentWishListsDataView.isLoading
        ) {
            this.props.loadWishLists(recentWishListsParameter);
        }
    }

    toggleFavoriteClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isFavorite: !wishList.isFavorite,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    toggleHideClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isHidden: !wishList.isHidden,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    /* Starter Custom Code - Start */
    deleteButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            deleteListModalIsOpen: true,
        });
    };

    deleteCancelHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
    };

    deleteSubmitHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishList({
                wishListId: this.state.wishListToAction.id,
                onSuccess: this.onDeleteSuccess,
                onComplete(resultProps) {
                    if (!resultProps.error) {
                        this.onSuccess?.();
                    }
                },
            });
        }
    };

    onDeleteSuccess = () => {
        this.context.addToast({ body: translate("List Deleted"), messageType: "success" });
        this.props.trackDeleteWishList({}, { wishList: this.state.wishListToAction }); // Starter Custom Code
    };

    leaveButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            leaveListModalIsOpen: true,
        });
    };

    leaveCancelHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
    };

    leaveSubmitHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishListShare({
                wishList: this.state.wishListToAction,
                onSuccess: this.onLeaveSuccess,
                onComplete() {
                    this.onSuccess?.();
                },
            });
        }
    };

    onLeaveSuccess = () => {
        this.context.addToast({ body: translate("You left the list"), messageType: "success" });
    };
    /* Starter Custom Code - End */

    render() {
        if (!this.props.canViewWishLists) {
            return null;
        }

        const {
            persistentDataView: { value: recentWishLists }, // Starter Custom Code
            myListsPageNavLink,
        } = this.props;
        const myListsPageUrl = myListsPageNavLink ? myListsPageNavLink.url : undefined;

        /* Starter Custom Code - Start */
        const hasNoResults = !recentWishLists || recentWishLists.length === 0;
        const showFavorites = getWishlistShowFavorites(recentWishLists);
        const showTags = getWishlistShowTags(recentWishLists);

        return (
            <StyledWrapper {...styles.wrapper}>
                <CardListHeading
                    heading={translate("My Lists")}
                    viewAllUrl={myListsPageUrl}
                    hasNoResults={hasNoResults}
                />
                <DataViewLoadingOverlay {...styles.loadingOverlay} dataView={this.props.persistentDataView}>
                    {hasNoResults ? (
                        <Typography {...styles.noWishListsText}>{siteMessage("WishLists_NoWishlistsFound")}</Typography>
                    ) : (
                        <StyledWrapper {...styles.tableWrapper}>
                            <DataTable {...styles.dataTable}>
                                <DataTableHead>
                                    {(showFavorites || showTags) && (
                                        <DataTableHeader {...styles.actionsHeader}>
                                            <VisuallyHidden>{translate("Actions")}</VisuallyHidden>
                                        </DataTableHeader>
                                    )}
                                    <DataTableHeader {...styles.listNameHeader}>{translate("Name")}</DataTableHeader>
                                    <DataTableHeader {...styles.dateHeader}>
                                        {translate("Last Updated")}
                                    </DataTableHeader>
                                    <DataTableHeader {...styles.itemsHeader}>{translate("# Items")}</DataTableHeader>
                                    <DataTableHeader {...styles.statusHeader}>{translate("Status")}</DataTableHeader>
                                    <DataTableHeader {...styles.actionsHeader}>
                                        <VisuallyHidden>{translate("Actions")}</VisuallyHidden>
                                    </DataTableHeader>
                                </DataTableHead>
                                <DataTableBody>
                                    {recentWishLists?.map(wishList => (
                                        <WishListCard
                                            key={wishList.id}
                                            wishList={wishList}
                                            addWishListToCart={this.props.addWishListToCart}
                                            deleteWishList={() => this.deleteButtonClickHandler(wishList)}
                                            leaveWishList={() => this.leaveButtonClickHandler(wishList)}
                                            extendedStyles={styles.wishListCard}
                                            toggleFavorite={() => this.toggleFavoriteClickHandler(wishList)}
                                            toggleHide={() => this.toggleHideClickHandler(wishList)}
                                            showFavorites={showFavorites}
                                            showTags={showTags}
                                        />
                                    ))}
                                </DataTableBody>
                            </DataTable>
                        </StyledWrapper>
                    )}
                    <TwoButtonModal
                        modalIsOpen={this.state.deleteListModalIsOpen}
                        headlineText={translate("Delete List")}
                        messageText={`${translate("Are you sure you want to delete")} ${
                            this.state.wishListToAction ? this.state.wishListToAction.name : ""
                        }?`}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Delete")}
                        onCancel={this.deleteCancelHandler}
                        onSubmit={this.deleteSubmitHandler}
                        submitTestSelector="myListsListSubmitDelete"
                    ></TwoButtonModal>
                    <TwoButtonModal
                        modalIsOpen={this.state.leaveListModalIsOpen}
                        headlineText={translate("Leave List")}
                        messageText={`${translate("Are you sure you want to leave")} ${
                            this.state.wishListToAction ? this.state.wishListToAction.name : ""
                        }?`}
                        cancelButtonText={translate("Cancel")}
                        submitButtonText={translate("Leave")}
                        onCancel={this.leaveCancelHandler}
                        onSubmit={this.leaveSubmitHandler}
                        submitTestSelector="myListsListSubmitLeave"
                    ></TwoButtonModal>
                </DataViewLoadingOverlay>
            </StyledWrapper>
        );
        /* Starter Custom Code - End */
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHookProps(RecentWishLists, hookPropsInjector)), // Starter Custom Code
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.numberOfRecords,
                displayName: "Number of Lists Displayed",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 3,
                fieldType: "General",
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
